/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { assistantsGetManaged } from "../funcs/assistantsGetManaged.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Assistant } from "../models/components/assistant.js";
import {
  GetManagedAssistantRequest,
  GetManagedAssistantSecurity,
} from "../models/operations/getmanagedassistant.js";
import { unwrapAsync } from "../types/fp.js";
export type AssistantsGetManagedQueryData = Assistant;

export function prefetchAssistantsGetManaged(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetManagedAssistantRequest | undefined,
  security?: GetManagedAssistantSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAssistantsGetManagedQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAssistantsGetManagedQuery(
  client$: GramCore,
  request?: GetManagedAssistantRequest | undefined,
  security?: GetManagedAssistantSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AssistantsGetManagedQueryData>;
} {
  return {
    queryKey: queryKeyAssistantsGetManaged({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function assistantsGetManagedQueryFn(
      ctx,
    ): Promise<AssistantsGetManagedQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(assistantsGetManaged(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAssistantsGetManaged(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "assistants", "getManaged", parameters];
}
